import script from "./ProdutoRotuloSolicitacaoLista_29.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutoRotuloSolicitacaoLista_29.vue?vue&type=script&setup=true&lang=js"

import "./ProdutoRotuloSolicitacaoLista_29.vue?vue&type=style&index=0&id=62e91126&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e91126"]])

export default __exports__